<script setup>
import {CheckCircleIcon} from '@heroicons/vue/solid'
</script>

<template>
    <button type="button" class="inline-flex items-center py-2 my-2 px-3 mr-3 border border-transparent rounded-full
    border-blue-400  ">
        <slot>
            <CheckCircleIcon class="-ml-1 mr-0.5 h-5 w-5 text-blue-400" aria-hidden="true"/>
            <span class="text-sm font-medium text-blue-400">
                {{ $tt('content_page__header_completed_button') }} <span class="sr-only"></span>
            </span>
        </slot>
    </button>
</template>
